import { Flex, Space, Typography, Row, Col } from "antd"

import classes from "./OrderReportValue.module.scss"

import { IDepotReport } from "@/types/IOrderReport"

import { formatFuelAmount, getMoney } from "@/utils/formatNumber"

export interface IOrderReportValueProps {
    orderAmount: number
    orderSum: number
}

export const OrderReportValue = (props: IOrderReportValueProps) => {
  const {
    orderAmount,
    orderSum
  } = props

  return (
    <>
      <Flex gap="middle">
            <span className={classes["fuel-amount-text"]}>
                {formatFuelAmount(orderAmount)} тн
            </span>
            <span className={classes["money-text"]}>
                {getMoney(orderSum)}
            </span>
      </Flex>
    </>

  )
}

export default OrderReportValue
